// =============================================================
// SKILLS — grouped skill chips shown in the Skills section.
// Add/remove items freely; add a whole new group by copying a block.
// =============================================================
export const skills = [
  { group: "Languages", items: ["French (fluent)", "English (fluent)"] },
  { group: "Programming", items: ["Python", "Java", "HTML / CSS / JavaScript"] },
  { group: "Libraries & Databases", items: ["FastAPI", "Pytest", "React", "PostgreSQL"] },
  {
    group: "Tools & Software",
    items: ["Git", "VS Code", "Jira", "Zephyr Scale", "Confluence", "Google Workspace"],
  },
  {
    group: "Methodologies",
    items: [
      "Agile / Scrum",
      "Manual Testing",
      "Regression Testing",
      "Integration Testing",
      "Defect Lifecycle Management",
    ],
  },
];
